export default {
  title: 'עריכת פרטי הסוכן {1}',
  subtitle: 'עודכן לאחרונה בתאריך {1}',
  more: 'צפה עוד',
  delete: 'העברת סוכן לארכיון',
  succesdDelete: 'הסוכן הועבר לארכיון בהצלחה',
  menu: {
    details: 'פרטים',
    contracts: 'הסכמים',
    documents: 'מסמכים',
    clients: 'תיקים',
    expenses: 'הוצאות',
    income: 'הכנסות',
  },
  status: {
    active: 'פעיל',
    archive: 'ארכיון',
  },
  agentType: {
    CTO: 'מנכ"ל',
    houseAgent: 'סוכן בית',
    integratedAgent: 'סוכן משולב',
    foreignAgent: 'סוכן חוץ',
  },
  employeeType: {
    employee: 'שכיר',
    selfEmployee: 'עצמאי',
  },
  side: {
    tabs: 'מידע נוסף',
    comments: 'הערות',
    histories: 'היסטוריה',
    actions: 'פעולות',
  },
  headers: {
    private: 'פרטים אישיים',
    contact: 'פרטי קשר',
    home: 'בית',
    office: 'משרד',
    status: 'סטטוס',
    action: 'פעולות',
    history: 'היסטוריה',
    comment: 'הערות',
    contracts: 'הסכמים',
    extra: 'מידע נוסף',
    family: 'משפחה',
    dates: 'תאריכים',
    documents: 'מסמכים',
    clients: 'ניהול מספרי תיק/יישות',
  },
  remarks: {
    action: 'נהל הערות סוכן',
  },
  history: {
    action: 'צפה בכל ההיסטוריה',
  },
  notification: {
    success: {
      title: 'הפרטים עודכנו בהצלחה',
      message: 'פרטי הסוכן עודכנו במערכת',
    },
    failure: {
      title: 'הפרטים לא עודכנו',
      message: 'אירעה שגיאה בניסיון העדכון',
    },
    validtion: {
      title: 'הפרטים לא עודכנו',
      message: 'אחד מהפרטים שהוזנו איזו תקין',
    },
    download: {
      title: '',
      message: 'הקובץ נמצא בתהליך הורדה',
    },
    downloadFaild: {
      title: '',
      message: 'הקובץ נכשל בהורדה',
    },
  },
};
